import { render, staticRenderFns } from "./StaffView.vue?vue&type=template&id=3de21f4e&scoped=true&"
import script from "./StaffView.vue?vue&type=script&lang=js&"
export * from "./StaffView.vue?vue&type=script&lang=js&"
import style0 from "./StaffView.vue?vue&type=style&index=0&id=3de21f4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de21f4e",
  null
  
)

export default component.exports